import { httpsCallable } from "firebase/functions";
import { auth, functions } from "../firebase-config.js";
import privatePaths from "./premium-audio-manifest.json";

const protectedPaths = new Set(privatePaths);
const cache = new Map();
const pending = new Map();
const sourcePaths = new Map();
let queue = [];
let scheduled = false;

async function sendBatch(entries) {
  const uid = entries[0].uid;
  try {
    if (auth.currentUser?.uid !== uid) throw new Error("Le compte a changé.");
    const { data } = await httpsCallable(functions, "getPremiumAudioUrls", { timeout: 15000 })({ paths: entries.map((entry) => entry.path) });
    if (auth.currentUser?.uid !== uid) throw new Error("Le compte a changé.");
    entries.forEach((entry) => {
      const resource = data?.resources?.[entry.path];
      if (!resource?.url || !(resource.expiresAt > Date.now() + 60000)) {
        entry.reject(new Error("Audio temporairement indisponible."));
        return;
      }
      cache.set(entry.key, resource);
      sourcePaths.set(resource.url, entry.path);
      entry.resolve(resource.url);
    });
  } catch (error) {
    entries.forEach((entry) => entry.reject(error));
  } finally {
    entries.forEach((entry) => pending.delete(entry.key));
  }
}

function flushQueue() {
  scheduled = false;
  const entries = queue;
  queue = [];
  const groups = new Map();
  entries.forEach((entry) => {
    if (!groups.has(entry.uid)) groups.set(entry.uid, []);
    groups.get(entry.uid).push(entry);
  });
  groups.forEach((group) => {
    for (let index = 0; index < group.length; index += 12) void sendBatch(group.slice(index, index + 12));
  });
}

export async function resolveAudioSource(path) {
  const original = sourcePaths.get(path) || path;
  if (!protectedPaths.has(original)) return original;
  const uid = auth.currentUser?.uid;
  if (!uid) throw new Error("Connexion requise pour cet audio.");
  const key = `${uid}:${original}`;
  const saved = cache.get(key);
  if (saved && saved.expiresAt > Date.now() + 60000) return saved.url;
  if (pending.has(key)) return pending.get(key);
  const request = new Promise((resolve, reject) => queue.push({ uid, key, path: original, resolve, reject }));
  pending.set(key, request);
  if (!scheduled) { scheduled = true; queueMicrotask(flushQueue); }
  return request;
}

export async function refreshAudioSource(element) {
  const source = element?.src;
  if (!sourcePaths.has(source)) return;
  const next = await resolveAudioSource(source);
  if (element.src !== source || next === source) return;
  const time = element.currentTime;
  element.src = next;
  element.load();
  try { element.currentTime = time; } catch {}
}
